import React, { useState, useEffect } from "react";
import { Badge, Col, Row, Spinner, Table } from "react-bootstrap";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";

const RelatedListQuotationDetails = ({ parent, refreshList }) => {
    const [loading, setLoading] = useState(false);
    const [quotationData, setQuotationData] = useState(null);

    useEffect(() => {
        if (parent?.id) {
            fetchQuotation();
        }
    }, [parent?.id]);

    useEffect(() => {
        if (parent?.id && refreshList) {
            fetchQuotation();
        }
    }, [refreshList]);

    async function fetchQuotation() {
        if (!parent?.id) return;
        setLoading(true);
        setQuotationData(null);
        try {
            const result = await fuziElevatorsApi.fetchQuotationByOfferId(parent.id);
            setQuotationData(result);
        } finally {
            setLoading(false);
        }
    }

    const formatCurrency = (val) =>
        val != null ? Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "-";

    const items = quotationData?.items ?? [];
    const summary = quotationData?.summary ?? {};

    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" size="sm" /> Loading quotation...
            </div>
        );
    }

    if (!items.length) {
        return <p className="text-muted mb-0">No quotation generated yet.</p>;
    }

    return (
        <>
            <Table striped bordered hover size="sm" className="mb-4">
                <thead className="bg-light">
                    <tr>
                        <th>Item Name</th>
                        <th>Calculation Type</th>
                        <th>Quantity</th>
                        <th>Rate</th>
                        <th>Line Total</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, idx) => (
                        <tr key={idx}>
                            <td>{item.item_name ?? "-"}</td>
                            <td>
                                <Badge bg="secondary">{item.calculation_type ?? "-"}</Badge>
                            </td>
                            <td>{item.quantity != null ? Number(item.quantity).toLocaleString() : "-"}</td>
                            <td>₹ {formatCurrency(item.rate)}</td>
                            <td>₹ {formatCurrency(item.line_total)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <hr className="my-4" />

            <div
                className="quotation-summary p-4 rounded shadow-sm"
                style={{
                    backgroundColor: "#ffffff",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                    color: "#000000",
                }}
            >
                <Row className="mb-2">
                    <Col sm={4}><span style={{ color: "#000000", fontWeight: 600 }}>Subtotal</span></Col>
                    <Col sm={8} style={{ color: "#000000" }}>₹ {formatCurrency(summary.subtotal)}</Col>
                </Row>
                <Row className="mb-2">
                    <Col sm={4}><span style={{ color: "#000000", fontWeight: 600 }}>Margin</span></Col>
                    <Col sm={8} style={{ color: "#000000" }}>₹ {formatCurrency(summary.margin_amount)}</Col>
                </Row>
                <Row className="mb-2">
                    <Col sm={4}><span style={{ color: "#000000", fontWeight: 600 }}>Discount</span></Col>
                    <Col sm={8} style={{ color: "#000000" }}>₹ {formatCurrency(summary.discount_amount)}</Col>
                </Row>
                <Row className="mb-2">
                    <Col sm={4}><span style={{ color: "#000000", fontWeight: 600 }}>GST %</span></Col>
                    <Col sm={8} style={{ color: "#000000" }}>{summary.gst_percentage != null ? `${summary.gst_percentage}%` : "-"}</Col>
                </Row>
                <Row className="mb-2">
                    <Col sm={4}><span style={{ color: "#000000", fontWeight: 600 }}>GST Amount</span></Col>
                    <Col sm={8} style={{ color: "#000000" }}>₹ {formatCurrency(summary.gst_amount)}</Col>
                </Row>
                <Row className="mt-4 pt-3 border-top" style={{ borderColor: "#dee2e6" }}>
                    <Col sm={4}><strong className="fs-5" style={{ color: "#0d6efd" }}>Final Offer</strong></Col>
                    <Col sm={8}><strong className="fs-5" style={{ fontSize: "1.25rem", color: "#0d6efd" }}>₹ {formatCurrency(summary.final_offer)}</strong></Col>
                </Row>
            </div>
        </>
    );
};

export default RelatedListQuotationDetails;
